import * as React from 'react';
import styled from "styled-components";
import {Background, Overlay} from "../styled-components/Overlay";
import I18n from '../utils/i18n';
import {analyticsEvent} from "../utils/analytics";

const Title = styled.div`
  font-family: "Pixel Coleco";
  font-size: 4vh;
  text-align: center;
  color: #fed230;
`;

const Subtitle = styled.div`
    font-family: "Pixel Coleco";
    font-size: 2vh;
    text-align: center;
    color: #ffffff;
    margin-top: 2vh;
`;

const Embed = styled.div`
    margin-top: 3vh;
    width: 35vw;
    height: 33vh;
`;

const CloseButton = styled.div`
    font-family: "Pixel Coleco";
    font-size: 2vh;
    text-align: center;
    color: #0c80df;
    margin-top: 5vh;
    cursor: pointer;
`;

export class HelpOverlay extends React.Component {

    constructor() {
        super();
        this.onPlayerStateChange = this.onPlayerStateChange.bind(this);
        this.addVideo = this.addVideo.bind(this);
    }

    onPlayerStateChange(event) {
        const {screen} = this.props;
        switch(event.data) {
            case window['YT'].PlayerState.PLAYING:
                analyticsEvent('Onboarding',
                    'Need Help',
                    'Video Played',
                    screen
                );
                break;
        }
    }

    addVideo() {
        this.YT = window['YT'];
        this.player = new window['YT'].Player('youtube-video', {
            videoId: '1CgTLyVBSBk',
            modestbranding: true,
            controls: 0,
            events: {
                'onStateChange': this.onPlayerStateChange,
            }
        });
    }


    componentDidMount() {
        const {screen} = this.props;
        analyticsEvent('Onboarding',
            'Need Help',
            'Shown',
            screen
        );
        if(document.querySelectorAll('#youtube-api').length > 0) {
            this.addVideo();
        } else {
            // inject youtube api
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            tag.id = "youtube-api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            // add youtube video + handler
            window['onYouTubeIframeAPIReady'] = () => {
                this.addVideo();
            };
        }
    }


    render() {
        const {closeHelpOverlay, screen} = this.props;
        return (
            <Background>
                <Overlay>
                    <Title>{I18n.translate('needHelpPopupTitle')}</Title>
                    <Subtitle>{I18n.translate('needHelpPopupSubtitle')}</Subtitle>

                    <Embed id="youtube-video" />
                    <CloseButton onClick={() => {
                        closeHelpOverlay();
                        analyticsEvent('Onboarding',
                            'Need Help',
                            'Closed',
                            screen
                        );
                    }}>{I18n.translate('needHelpPopupClose')}</CloseButton>
                </Overlay>
            </Background>
        );
    }
}
